// mobile_menu_controller.js
// known: Firefox DevTools flags Stimulus internal layout reads on connect
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "hamburgerIcon", "closeIcon"]

  connect() {
    // Defer one frame so Firefox doesn't flag a forced layout
    // on initial connect before first paint completes
    requestAnimationFrame(() => this.close())
  }

  toggle() {
    const isOpen = this.overlayTarget.classList.contains("menu-open")
    isOpen ? this.close() : this.open()
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("menu-open")
    this.hamburgerIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    this.element.querySelector("button[aria-expanded]").setAttribute("aria-expanded", "true")
    // Move focus to first nav link inside the overlay
    const firstLink = this.overlayTarget.querySelector("a")
    if (firstLink) firstLink.focus()
    this.overlayTarget.setAttribute("aria-hidden", "false")
  }

  close() {
    this.overlayTarget.classList.remove("menu-open")
    this.overlayTarget.classList.add("hidden")
    this.hamburgerIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    document.body.style.overflow = ""
    const btn = this.element.querySelector("button[aria-expanded]")
    btn.setAttribute("aria-expanded", "false")
    // Return focus to the toggle button
    btn.focus()
    this.overlayTarget.setAttribute("aria-hidden", "true")
  }
}
